export { Highlight, HighlightProps } from './Highlight'
